import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';

export { default as PropertyList } from './PropertyList.vue';
export { default as PropertyListItem } from './PropertyListItem.vue';
export { default as PropertyListItemLabel } from './PropertyListItemLabel.vue';
export { default as PropertyListItemValue } from './PropertyListItemValue.vue';

export const propertyListVariants = cva('group flex', {
  defaultVariants: {
    orientation: 'vertical',
    size: 'default',
    width: 'full',
  },
  variants: {
    orientation: {
      horizontal: 'flex-row item-vertical',
      vertical: 'flex-col item-horizontal',
    },
    size: {
      default: 'text-xs gap-3',
      full: 'w-full! text-sm',
      sm: 'text-xs gap-1',
    },
    width: {
      default: '',
      full: 'full w-full',
    },
  },
});

export type PropertyListVariants = VariantProps<typeof propertyListVariants>;
